const ROTACION_LABELS = {
  liquidacion: 'Liquidación',
  sin_ventas: 'Sin ventas',
  lento: 'Lento (+90d)',
  alta_rotacion: 'Alta rotación',
  normal: 'Normal',
};

const MAX_LABEL_LENGTH = 48;

export const shortVehicleLabel = (vehiculo) => {
  const parts = String(vehiculo || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 3) return parts.slice(1, 3).join(' ');
  if (parts.length === 2) return parts[1];
  return parts[0] || '';
};

const trimLabel = (label) => {
  if (!label) return 'Búsqueda';
  return label.length > MAX_LABEL_LENGTH ? `${label.slice(0, MAX_LABEL_LENGTH)}…` : label;
};

export const buildCompactSearchLabel = ({
  filters = {},
  filtrosAtributos = {},
  categoryLabel = null,
} = {}) => {
  const parts = [];

  if (String(filters.nombre_producto || '').trim()) {
    parts.push(String(filters.nombre_producto).trim());
  }
  if (String(filters.vehiculo || '').trim()) {
    parts.push(shortVehicleLabel(filters.vehiculo));
  }
  if (String(filters.sku || '').trim()) parts.push(String(filters.sku).trim());
  if (String(filters.codigo_barras || '').trim()) parts.push(String(filters.codigo_barras).trim());
  if (String(filters.medidas || '').trim()) parts.push(String(filters.medidas).trim());
  if (String(filters.nombre_marca || '').trim()) parts.push(String(filters.nombre_marca).trim());
  if (categoryLabel) {
    parts.push(String(categoryLabel).trim());
  } else if (String(filters.id_categoria || '').trim()) {
    parts.push(`cat.${filters.id_categoria}`);
  }
  if (String(filters.estado_rotacion || '').trim()) {
    parts.push(ROTACION_LABELS[filters.estado_rotacion] || filters.estado_rotacion);
  }

  const firstAttr = Object.values(filtrosAtributos || {}).find((v) => String(v || '').trim());
  if (firstAttr) parts.push(String(firstAttr).trim());

  if (parts.length === 0) return 'Búsqueda guardada';
  return trimLabel(parts.join(' '));
};

export const buildCompactLabelFromQueryFilters = (queryFilters = []) => {
  const parts = [];
  for (const item of queryFilters) {
    if (!item?.value) continue;
    if (item.key === 'vehiculo') {
      parts.push(shortVehicleLabel(item.value));
    } else if (item.key === 'atributos') {
      const raw = String(item.value);
      const firstVal = raw.split(',').map((s) => s.split('=').pop()?.trim()).find(Boolean);
      if (firstVal) parts.push(firstVal);
    } else {
      parts.push(String(item.value).trim());
    }
  }
  if (parts.length === 0) return 'Búsqueda';
  return trimLabel(parts.join(' '));
};

export const resolveCategoryLabel = (idCategoria, categoryOptions = []) => {
  if (!idCategoria) return null;
  const match = categoryOptions.find((o) => String(o.value) === String(idCategoria));
  return match?.label || null;
};
